import RequesterBuilder from "@/assets/plugins/mps-common/network/requester-builder";
import {PATH} from "@/constants";
import utilManager from "@/assets/plugins/mps-common/util/util-manager";

class RentalCompany {
    _item;

    constructor(item) {
        this._item = item || {};
    }

    get key() {
        return this._item.rentalcompanyId;
    }

    get raw() {
        return this._item;
    }

    get approved() {
        return this._item.approvedYn === "Y";
    }

    get isFile() {
        return this._item.fileCount > 0;
    }

    /**
     * 임대업체 승인처리
     */
    async approve() {
        await new RequesterBuilder()
            .path(PATH.MEMBERSHIP.APPROVE)
            .loading()
            .setObject({
                rentalcompanyId: this.raw.rentalcompanyId,
            })
            .catch()
            .enqueue();
        this._item.approvedYn = "Y" // 클라이언트에서 완료 처리 해버립니다.
    }

    async updateAutomationStatus(type) {
        const res = await new RequesterBuilder()
            .path(PATH.MEMBERSHIP.UPDATE_AUTO_STATUS, this.raw.rentalcompanyId, type)

            .catch()
            .enqueue();
        switch (type) {
            case 'useYn': this._item.useYn = res
                break;
            case 'useAutoUsage': this._item.useAutoUsage = res
                break;
            case 'useAutoSales': this._item.useAutoSales = res
                break;
            case 'useAutoCms': this._item.useAutoCms = res
                break;
            case 'useAutoTax': this._item.useAutoTax = res
                break;
            default:
                throw new Error('Auto type is ' + type)
        }
    }

    /**
     * 임대업체 재승인 메일 발송
     * @returns {Promise<void>}
     */
    async reapprove() {
        await new RequesterBuilder()
            .path(PATH.MEMBERSHIP.REAPPROVE)
            .loading()
            .setObject({
                rentalcompanyId: this.raw.rentalcompanyId,
            })
            .catch()
            .enqueue();
    }

    /**
     * 거래처 & 영업점의 위도 경도 값을 초기화 없이 업데이트
     * 즉, 현재 주소 값은 존재하지만 위도 경도 값이 없는 거래처 & 영업점만 루프
     */
    async loopLatLng() {
        return await new RequesterBuilder()
            .path(PATH.LAT_LNG.LOOP_ACCOUNT_AND_BRANCH)
            .loading()
            .setObject({
                rentalcompanyId: this.raw.rentalcompanyId,
            })
            .catch()
            .enqueue();
    }

    /**
     * 거래처 & 영업점의 위도 경도 값을 초기화 후 업데이트
     */
    async loopLatLngWithReset() {
        return await new RequesterBuilder()
            .path(PATH.LAT_LNG.LOOP_ACCOUNT_AND_BRANCH_RESET)
            .loading()
            .setObject({
                rentalcompanyId: this.raw.rentalcompanyId,
            })
            .catch()
            .enqueue();
    }

    async getMigrationDataList(id){
        return await new RequesterBuilder()
            .path(PATH.MEMBERSHIP.GET_MIGRATION_DATA + id)
            .catch()
            .enqueue();
    }


}

export {RentalCompany};
